/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import { ActivityRegistration } from '/components/activity-registration/components';

(() => {
    const activityRegistrationContainer = document.querySelector(
        '[data-activity-registration-container]',
    );

    const { id, socialPricing } = activityRegistrationContainer.dataset;

    ReactDOM.render(
        <ActivityRegistration id={id} socialPricing={Boolean(socialPricing)} />,
        activityRegistrationContainer,
    );
})();
